// Deep clone elements into a new object
export default (ob) => JSON.parse(JSON.stringify(ob));
